import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import './styles/theme.css'
import './i18n'
import BookingPage from './BookingPage'
import LiffEntry from './LiffEntry'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* LINE LIFF entry — slug comes from ?slug=, not the path. Must precede /:slug. */}
        <Route path="/liff" element={<LiffEntry />} />
        <Route path="/:slug" element={<BookingPage />} />
        {/* In mock/dev there is no slug in the URL — land on the demo business. */}
        <Route path="/" element={<Navigate to="/demo" replace />} />
        <Route path="*" element={<Navigate to="/demo" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
)
